import React from 'react';
import PropTypes from 'prop-types';
import {useLocation, useHistory} from 'react-router-dom';
import {parse} from 'query-string';

import {isEmpty} from 'front-onceforall-core/dist/utils/strings';
import {usePrevious} from 'front-onceforall-core/dist/utils/customHooks';

import OrganisationProjectListView from './OrganisationProjectListView';

// This is used to force resetting data when unmounting component only if a search has been made (page or query)
let toReset = false;

function OrganisationProjectListContainer(props) {
  const location = useLocation();
  const prevLocation = usePrevious(location.pathname + location.search);
  const history = useHistory();
  const [pageNumber, setPageNumber] = React.useState(typeof parse(location.search).page === 'undefined' ? 0 : Number(parse(location.search).page));

  React.useEffect(() => {
    if (prevLocation && prevLocation !== (location.pathname + location.search)) {
      props.onPageChange();
    }
  });

  React.useEffect(() => {
    toReset = !isEmpty(location.search);
    return () => {
      if (toReset) {
        props.onPageChange();
      }
    };
  }, []);

  function handlePageChange(event, page) {
    toReset = true;
    setPageNumber(page);
    history.push(`${location.pathname}?page=${page}`);
  }

  return (
    <OrganisationProjectListView
      interventions={props.interventions}
      pageSize={props.pageSize}
      totalCount={props.totalCount}
      loading={props.loading}
      error={props.error}
      onPageChange={handlePageChange}
      pageNumber={pageNumber}
      showDossierState={props.showDossierState}
    />
  );
}

OrganisationProjectListContainer.propTypes = {
  interventions: PropTypes.array.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  showDossierState: PropTypes.bool
};

export default OrganisationProjectListContainer;
